import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=8d2d28ae&scoped=true"
import script from "./Overview.vue?vue&type=script&lang=ts&setup=true"
export * from "./Overview.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Overview.vue?vue&type=style&index=0&id=8d2d28ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2d28ae",
  null
  
)

export default component.exports